import { Component, OnInit } from '@angular/core';
import { AdminServiceService } from 'src/app/services/admin-service.service';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { Label } from 'ng2-charts';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';

declare var $:any;

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styles: [
  ]
})
export class PaymentsComponent implements OnInit {
  
  public payments = [];
  
  constructor(private adminService:AdminServiceService) { }

  ngOnInit(): void {
    this.adminService.getPayments().subscribe(
      resp=>{
        this.payments = resp;
        this.payments.sort((a,b)=>{
          let dateA = new Date(a.date);
          let dateB = new Date(b.date);
          return dateB.getTime() - dateA.getTime();
        });
        setTimeout(()=>{
          $('#example23').DataTable({
            dom: 'Bfrtip',
            buttons: [
                'copy', 'csv', 'excel', 'pdf', 'print'
            ],
            ordering:false
        });
        },500)
      },
      err=>console.log(err)
    )
  }

}
